import { UserFeatureFlag } from '@@types/api.types';
import { MainLayout } from '@components/layouts/main.layout';
import { generateUUID } from '@lib/utils';
import { useGetCurrentUser } from '@queries/users.query';
import { routes } from '@routes';
import { Navigate } from 'react-router-dom';
import { HelmetWrapper } from '../../shared/helmet.component';
import { PageviewTracker } from '../../shared/pageview-tracker.component';
import { Chat } from './components/chat/chat.component';

export const ResearchPage: React.FC = () => {
  const chatId = generateUUID();
  const { data: user, isPending } = useGetCurrentUser();
  const hasResearchTool = user?.featureFlags?.includes(UserFeatureFlag.RESEARCH_TOOL);

  if (!isPending && !hasResearchTool) {
    return <Navigate to={routes.home.path} />;
  }

  return (
    <PageviewTracker>
      <HelmetWrapper title="Research" />
      <MainLayout
        asideClassName="hidden"
        className="h-[calc(100svh-var(--impersonation-banner-height,0px))] max-w-full p-0"
        contentClassName="w-full md:max-w-full h-full"
      >
        <div className="h-full w-full overflow-hidden">
          <Chat
            id={chatId}
            initialMessages={[]}
            isPending={isPending}
          />
        </div>
      </MainLayout>
    </PageviewTracker>
  );
};
